module.exports = __webpack_public_path__ + "img/purple_wave@2x.51b3766d.png";